import Toolbar from "../sections/toolbar";

export default class ToolbarView extends Toolbar {
	config() {
		const _ = this.app.getService("locale")._;
		const state = this.getParam("state");
		const ui = super.config();
		ui.rows[0].cols.push({
			view: "toggle",
			width: 150,
			type: "icon",
			icon: "umi-matrix",
			label: this.app.config.roles ? _("Role Matrix") : _("Rule Matrix"),
			on: {
				onChange: v => this.ToggleVisible(v, state),
			},
		});

		return ui;
	}

	ToggleVisible(v, state) {
		state.mode = v ? "matrix" : "grid";
	}
}
